export enum GlProductTypeEnum {
  WARES = 'WARES',
  SERVICES = 'SERVICES',
  ANY = 'ANY',
}
